/*eslint-disable*/
import _ from 'lodash';
import axios from 'axios';
import Vue from 'vue';
import i18n from '../build/services/vuei18n';
import router from '../router';
import store from '../store';
import { isTariffLimitError, showTariffLimitToast } from '@/utils/tariffLimitErrors';

const REQUEST_ABORTED_ERROR_CODE = 'ECONNABORTED';
const DEFAULT_RESPONSE_ON_ABORTED_ERROR = { data: {} };

class Api {
    constructor() {
        this.axios = axios.create({
            baseURL: api.env.API_ENDPOINT + '/',
            headers: {
                Accept: `application/cs-api.v${env.apiVersion}+json, text/plain, */*`
            }
        });
        this.axios.interceptors.request.use((config) => {
            config.params = this.convertObjectKeys(config.params, _.snakeCase);
            if (config.data instanceof FormData) {
                return config
            }
            config.data = this.convertObjectKeys(config.data, _.snakeCase);
            return config
        }, (error) => {
            return Promise.reject(error)
        });

        this.axios.interceptors.response.use((response) => {
            response.data = this.convertObjectKeys(response.data, _.camelCase);
            return response;
        }, (error) => {
            if (_.has(error, 'response.data.message')) {
                if (error.response.data.message === 'Token has expired') {
                    Vue.toasted.error(i18n.t('errors.session_timeout'));
                    router.push({name: 'login'});
                    return;
                }
                if (error.response.data.message === 'ARCHIVED USER (403)') {
                    router.push({name: 'archived-user'});
                    return;
                }
                if (error.response.data.message === 'USER IN ARCHIVED GRADE (403)') {
                    router.push({name: 'without-active-grades'});
                    return;
                }
                if (error.response.data.message === 'USER IN ARCHIVED SCHOOL (403)') {
                    router.push({name: 'without-active-schools'});
                    return;
                }
                error = error.response;
                if (error.status === 503) {
                    if (router.currentRoute.name !== 'update-in-progress') {
                        router.push({name: "update-in-progress"});
                    }
                }
                if (error.status === 403) {
                    router.push({name: '403'} );
                }
                if (error.status !== 403 && error.status !== 404 && error.status !== 503) {
                    if (isTariffLimitError(error.data.message)) {
                        showTariffLimitToast(error.data.message, {
                            i18n,
                            router,
                            toasted: Vue.toasted,
                        });
                    } else {
                        const toastParams = {};
                        if (error.data.charged_sum !== undefined && error.data.charged_sum !== null) {
                            toastParams.sum = error.data.charged_sum;
                        }
                        Vue.toasted.error(i18n.t(`errors.${error.data.message}`, toastParams));
                    }
                    if (error.data.errors) {
                        Object.values(error.data.errors).forEach((err) => {
                            Vue.toasted.error(err[0])
                        });
                    }
                    if (error.data.message === 'The token has been blacklisted') {
                        Vue.toasted.error(i18n.t('errors.login_from_another_device'));
                        store.dispatch('logOut');
                        router.push('/auth/');
                    }
                }
                if (!error.response && error.status !== 503 && error.status !== 422) {
                    Vue.toasted.error(i18n.t('errors.error_has_occurred'));
                }
            }
            if (error.code === REQUEST_ABORTED_ERROR_CODE) {
                return Promise.resolve(DEFAULT_RESPONSE_ON_ABORTED_ERROR);
            }
            return Promise.reject(error);
        });
    }

    generateCancelToken() {
        return axios.CancelToken.source()
    }

    getPlainAxios() {
        return axios
    }

    setToken(token) {
        if (token) {
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            Vue.prototype.$echo.connector.options.auth.headers['Authorization'] = 'Bearer ' + token
        } else {
            delete this.axios.defaults.headers.common['Authorization'];
            delete Vue.prototype.$echo.connector.options.auth.headers['Authorization'];
        }
    }

    convertObjectKeys(object, func) {
        func = func || _.camelCase;
        if (!_.isObject(object)) {
            return object;
        }
        return _.mapValues(
            _.mapKeys(object, (value, key) => func(key)),
            (value) => {
                if (_.isObject(value)) {
                    if (_.isArray(value)) {
                        return _.map(value, (val) => this.convertObjectKeys(val, func));
                    } else {
                        return this.convertObjectKeys(value, func);
                    }
                }
                return value;
            }
        );
    }
}

export default new Api();
